module.exports = __webpack_public_path__ + "u2.no2.04a2ad3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u2.no2.jpg
// module id = JGLD
// module chunks = 0